// extracted by mini-css-extract-plugin
export default {"truncated-text":"UiModuleFieldsHeader_truncated-text__WyLtM","truncatedText":"UiModuleFieldsHeader_truncated-text__WyLtM","header":"UiModuleFieldsHeader_header__KKgpk"};